import React from 'react';
import { Field, formValues, reduxForm } from 'redux-form';
import axios from 'axios';

import User from './User';
import uvt from '../static/logos/uvt-logo.jpg'
import uz from '../static/logos/uz-logo.jpg'
import upl from '../static/logos/upl-logo.jpg'
import udt from '../static/logos/udt-logo.jpg'
import umb from '../static/logos/umb-logo.jpg'
import ubi from '../static/logos/ubi-logo.jpg'
import '../index.css';

class Login extends React.Component {
    
    renderError({ error, touched}){
        if(touched && error) {
            return(
                <div className="ui error message">
                    <div className="header">{error}</div>
                </div>
            );
        }
    }

    renderInput = ( { input, label, meta }) => {
        const className = `field ${meta.error && meta.touched ? 'error' : ''}`;
        return (
            <div className={className}>
                <label>{label}</label>
                <input {...input} autoComplete="off" />
                {this.renderError(meta)}
            </div>
        );
    }

    renderPassword = ( { input, label, meta }) => {
      const className = `field ${meta.error && meta.touched ? 'error' : ''}`;
      return (
          <div className={className}>
              <label>{label}</label>
              <input {...input} autoComplete="off" type="password" />
              {this.renderError(meta)}
          </div>
      );
  }

    onSubmit = async (formValues) => {
        var loginInfo = new FormData();
        loginInfo.append("username",formValues.username);
        loginInfo.append("password",formValues.password);
        const response = await axios.post("https://innounita.univ-unita.eu/backend/auth/login", loginInfo)
        .then((response)=>{
            window.location = "/";
        })
        .catch ((error) => {
            console.log(error);
            alert(error.response.data.exception);
        })
        // User(response.data);
        console.log(User);
        
    }

    render () {  
         if (User.isLoggedIn){
            window.location = "/"
            return("")
        }
        return (
            <div className="login-body">
               <div className="ui container">
                    <div className="login-background">
                        <div className="ui left aligned container login-field">
                            <form onSubmit={this.props.handleSubmit(this.onSubmit)} className="ui form error">
                            <Field name="username" component={this.renderInput} label="Username" />
                            <Field name="password" component={this.renderPassword} label="Password" />
                            <div className="login-button">
                                <button className="ui button primary">Sign in</button>
                            </div>
                            </form>
                        </div>
                        <div className="secondary-login">
                            <div className="ui horizontal divider">Or</div>
                            <div><p className="login-button">Sign in with university account</p></div>
                            <div className="university-logos">
                                <a href='https://innounita.univ-unita.eu/backend/auth/uvt'><img className="university-logo" src={uvt}/></a>
                                <a href='#'><img className="university-logo" src={uz}/></a>
                                <a href='#'><img className="university-logo" src={upl}/></a>
                                <a href='#'><img className="university-logo" src={udt}/></a>
                                <a href='#'><img className="university-logo" src={umb}/></a>
                                <a href='#'><img className="university-logo" src={ubi}/></a>
                            </div>
                        </div>
                    </div>
                </div>
           </div>

        );
    }
}

const validate = (formValues) => {
    const errors = {};

    if (!formValues.username) {
        errors.username = 'You must enter a username';
    }

    if (!formValues.password) {
        errors.password = 'You must enter a password'
    }

    return errors;
};

export default reduxForm({
    form: 'Login',
    validate
})(Login);
